<template>
    <div>
        <h3>貸し本棚を宣伝する</h3>
        <div>
            <p>
                貸し本棚の宣伝は公式ツイッターアカウントのみで行っています。
                登録されたユーザー様のご協力があれば、貸し本棚をもっと多くの人に利用していただくことができ、
                より使いやすいWebアプリに改善していくことができます。
            </p>
            <h4>貸し本棚を宣伝する</h4>
            <p>
                マイページから、X/blueskyで貸し本棚の宣伝を投稿できます。
                このボタンから作成されたリンクから誰かが貸し本棚を訪れ、ユーザー登録した場合、
                紹介したユーザーの公開済み小説作品のエイジングが回復する恩恵を得られます。
            </p>
            <img src="/img/help/other/01.png" alt="宣伝ボタン" class="img-thumbnail mb-3">
            <h5>エイジングとは</h5>
            <p>
                貸し本棚のポータルに表示される「長編おすすめ」と「短編おすすめ」、「R18」、「XXX」の４カテゴリについては、
                内部的に<strong>イコライザ</strong>と呼ばれるロジックによって表示順位が決定されています。
            </p>
            <p>
                詳細なアルゴリズムは非公開ですが、<strong>すべての作品に均一に露出機会を与える</strong>という理念に基づいて設計されており、
                ランキングとは異なります。
                このアルゴリズムの重要な算出要素として「エイジング」という値があります。
                これは小説が公開されてから、時間の経過や訪問者によって徐々に増加していきます。
                エイジングが増加すると、おすすめの順位は低下します。
            </p>
            <p>
                エイジングはおすすめの順位決定の一要素であり、２つの小説のエイジング値が同じであっても、
                おすすめの順位が同一になるとは限りません。
            </p>
            <h5>エイジングの回復</h5>
            <p>
                マイページからSNSへ紹介を投稿すると、その紹介リンクは紹介者固有のものとなります。
                そのリンクを経由して貸し本棚を訪れた人がユーザー登録すると、
                紹介者の公開済み小説のエイジングが回復します。
            </p>
            <p>
                複数の公開済み小説が存在する場合、ピックアップの中から最もエイジングしている作品が選ばれます。
                ピックアップが無く、公開済み小説が複数存在する場合は、公開済み小説の中から最もエイジングしている作品が選ばれます。
                エイジングしている小説が無い場合、回復処理は実行されません。
            </p>
            <p>
                エイジングの回復は、１ユーザーの登録につき２５％、ユーザーのサブドメイン登録で２０％です。
                この回復値は予告なく調整されることがあります。
            </p>
            <h5>同一ユーザーによる複数アカウント登録</h5>
            <p>
                同一ユーザーが複数アカウント登録する場合、
                ２つめのアカウントで異なる種類の小説を投稿する、などの活動を予定していれば問題ありません。
                例えば、登録しているアカウントで公開用の小説を執筆しており、実験的作品を執筆して一部のユーザーのみに宣伝することを考える場合、
                サブアカウントでこれらの活動を行うことができます。
                そういった場合では、サブアカウント登録時にご自身のリンクを経由してユーザー登録することで、恩恵を得られます。
                この行為を、１アカウントに限り、貸し本棚は認めています。
            </p>
            <p>
                <strong>エイジングの回復を目的として</strong>サブアカウント登録を行い、それらのサブアカウントで執筆活動が確認できない場合、
                エイジングが増加するペナルティが課されることがあります。
            </p>
        </div>
    </div>
</template>

<style src="../help.scss" scoped lang="scss"></style>

<script>
export default {
    created() {
        this.useHead({
            title: "宣伝する | 貸し本棚ヘルプ",
            link: [
                {
                    rel: "canonical",
                    href: location.origin + location.pathname,
                    id: "canonical"
                }
            ]
        });
    }
}
</script>